import React from "react";
import styled from "styled-components";
import FormatQuoteIcon from "@mui/icons-material/FormatQuote";
import { Trans } from "react-i18next";

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  padding: 15px 24px;
  width: 100%;
  height: 100%;
  max-height: 560px;
  overflow-y: auto;
  font-family: "Noto Sans", sans-serif;
`;

const QuoteCard = styled.div`
  width: 100%;
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.duo.palette.blueMain};
  background: white;
  padding: 28px 24px;
`;

const QuoteMark = styled(FormatQuoteIcon)`
  color: ${({ theme }) => theme.duo.palette.blueMain};
  font-size: 40px;
  line-height: 1;
  margin-left: -7px;
`;

const QuoteText = styled.div`
  font-size: 24px;
  line-height: 1.4;
  font-weight: 600;

  & span {
    color: ${({ theme }) => theme.duo.palette.blueMain};
  }
`;

const Author = styled.div`
  margin-top: 18px;
  font-size: ${({ theme }) => theme.duo.fontSize.small};
  color: #6b747c;
`;

const SImage = styled.img<{ msDelay?: number }>`
  width: 100%;
  height: auto;
  opacity: 0;
  transform: translateY(6px);
  animation: fadeInImg 420ms ease-out forwards;
  animation-delay: ${({ msDelay = 0 }) => `${msDelay}ms`};

  @keyframes fadeInImg {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

const SocialProof: React.FC = () => {
  return (
    <Wrap>
      <QuoteCard>
        <QuoteMark />
        <QuoteText>
          <Trans>
            This is the first app that <span>truly works</span> for learning a language!
          </Trans>
        </QuoteText>
        <Author>SUSAN O’NEIL</Author>
      </QuoteCard>

      <SImage
        msDelay={60}
        src="https://imgs.duocards.com/onboarding/social-proof/rating-profile-images.png"
        alt="Users who love DuoCards"
      />

      <SImage
        msDelay={140}
        src="https://imgs.duocards.com/onboarding/social-proof/rating-badge.png"
        alt="4.7 out of 5 rating — 5,000,000+ users worldwide"
      />
    </Wrap>
  );
};

export default SocialProof;
